import React from "react";

// import components
import Apply from "../Sections/Apply";
import Contact from "../Sections/Contact";
import Footer from "../Sections/Footer";
import Navbar from "../Sections/Navbar";

import Landing from "../Components/Landing";
import Students from "../Components/Students";

const Alumni = () => {
  return (
    <div className="alumni">
      {/* __________________Navbar Section__________________________  */}
      <Navbar></Navbar>

      {/* __________________Landing Section__________________________  */}
      <Landing></Landing>

      {/* __________________Student Section__________________________  */}
      <Students></Students>

      {/* __________________Apply Section__________________________  */}
      <Apply></Apply>

      {/* __________________Contact Section__________________________  */}
      <Contact></Contact>

      {/* __________________Final Footer__________________________  */}
      <Footer></Footer>
    </div>
  );
};

export default Alumni;
